// src/components/Download.jsx
import React from "react";
import { FaApple, FaGooglePlay } from "react-icons/fa";

const STORE_LINKS = {
  appstore: "https://apps.apple.com/ci/app/goallfit/id6755972326",
  playstore: "https://play.google.com/store/apps/details?id=com.lsd.goalfit",
};

export default function Download() {
  const openStore = (store) => {
    try {
      if (typeof window !== "undefined" && window.gtag) {
        window.gtag("event", "open_store", {
          event_category: "engagement",
          event_label: store,
        });
      }
    } catch (error) {
      console.log("Tracking error", error);
    }

    const storeUrl = STORE_LINKS[store];
    if (storeUrl) {
      window.open(storeUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <section id="download" style={styles.section}>
      <div className="container" style={{ textAlign: "center" }}>
        <h2>Télécharger GoalFit</h2>

        <div style={styles.row}>
          <button
            onClick={() => openStore("appstore")}
            style={{ ...styles.storeBtn, ...styles.appleBtn }}
            aria-label="App Store"
          >
            <FaApple size={34} style={styles.icon} />
            <div style={styles.textBlock}>
              <span style={styles.smallText}>Disponible sur</span>
              <span style={styles.bigText}>App Store</span>
            </div>
          </button>

          <button
            onClick={() => openStore("playstore")}
            style={{ ...styles.storeBtn, ...styles.playBtn }}
            aria-label="Google Play"
          >
            <FaGooglePlay size={30} style={styles.icon} />
            <div style={styles.textBlock}>
              <span style={styles.smallText}>Disponible sur</span>
              <span style={styles.bigText}>Google Play</span>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}

const styles = {
  section: {
    padding: "70px 0",
    background:
      "linear-gradient(180deg, rgba(6,22,55,0.02) 0%, rgba(255,255,255,0) 100%)",
  },

  row: {
    marginTop: 25,
    display: "flex",
    justifyContent: "center",
    gap: 18,
    flexWrap: "wrap",
  },

  storeBtn: {
    display: "flex",
    alignItems: "center",
    padding: "14px 20px",
    borderRadius: 14,
    textDecoration: "none",
    color: "#fff",
    minWidth: 190,
    boxShadow: "0 8px 28px rgba(2,6,23,0.16)",
    border: "none",
    cursor: "pointer",
    transition: "all 260ms cubic-bezier(.2,.9,.3,1)",
  },

  appleBtn: {
    background: "#000",
  },

  playBtn: {
    background: "#1E1E1E",
  },

  icon: {
    marginRight: 12,
  },

  textBlock: {
    display: "flex",
    flexDirection: "column",
    lineHeight: 1.1,
    textAlign: "left",
  },

  smallText: {
    fontSize: 12,
    opacity: 0.8,
    color: "#ddd",
  },

  bigText: {
    fontSize: 18,
    fontWeight: 700,
    color: "#fff",
  },
};

const animStyle = document.createElement("style");
animStyle.innerHTML = `
  button[aria-label] { transform-origin: center; }
  button[aria-label]:hover { transform: translateY(-6px) scale(1.01); box-shadow: 0 12px 30px rgba(2,6,23,0.18); }
`;

document.head.appendChild(animStyle);
